import React, { useState, useEffect } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import Search from "../../../shares/search/Search";
import {
  DeleteOutlined,
  EditOutlined,
  QuizOutlined,
  AddRounded,
} from "@mui/icons-material";
import { Modal, CircularProgress } from "@mui/material";
import AddGroups from "./modals/AddQuestion";
import useFetch from "../../../../hooks/useFetch";
import moment from "jalali-moment";
import { useSearchParams } from "react-router-dom";
import {
  PageHeader,
  TableAction,
} from "../../../shares/dashboard/DashboardWidgets";

const Question = () => {
  const [newModal, setNewModal] = useState(false);
  const [questions, setQuestion] = useState();
  const [id, setId] = useState();
  const [edit, setEdit] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClose = () => {
    setNewModal(false);
    setEdit(null);
  };

  const handleEdit = (id) => {
    setNewModal(true);
    setEdit(id);
  };

  const getQuestion = useFetch({
    method: "GET",
    url: "management/questions/",
    params: { page: searchParams.get("page") || 1, search: searchParams.get("search") || "" },
    safeRead: true,
    noHeader: false,
    trigger: true,
    setter: setQuestion,
  });

  const deleteGroup = useFetch({
    method: "DELETE",
    url: `management/questions/${id}/`,
    noHeader: false,
    trigger: false,
    caller: getQuestion,
    argFunc: () => {
      if (questions?.results.length === 1) {
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev);
          next.set("page", Math.max(1, Number(searchParams.get("page") || 1) - 1));
          return next;
        });
      }
      setId(null);
    },
  });

  const columns = [
    { id: "question_headline", label: "نام" },
    { id: "question_answer", label: "پاسخ" },
    { id: "question_category", label: "مبحث" },
    { id: "question_book", label: "کتاب" },
    { id: "question_grade", label: "مقطع" },
    {
      id: "question_creation_time",
      label: "زمان سوال",
      render: (row) =>
        moment(row.question_creation_time, "YYYY/MM/DD HH:mm")
          .locale("fa")
          .format("YYYY/MM/DD HH:mm"),
    },
    {
      id: "question_img",
      label: "تصویر سوال",
      render: (row) =>
        row.question_img ? (
          <img
            src={row.question_img}
            className="relative z-0 mx-auto max-h-[6rem] w-full max-w-[10rem] rounded-card border border-rule-subtle object-cover transition-transform duration-200 hover:z-10 hover:scale-[2.5]"
            alt="تصویر سوال"
          />
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    {
      id: "question_answer_img",
      label: "تصویر پاسخ",
      render: (row) =>
        row.question_answer_img ? (
          <img
            src={row.question_answer_img}
            className="relative z-0 mx-auto max-h-[6rem] w-full max-w-[10rem] rounded-card border border-rule-subtle object-cover transition-transform duration-200 hover:z-10 hover:scale-[2.5]"
            alt="تصویر پاسخ"
          />
        ) : (
          <span className="text-ink-subtle">—</span>
        ),
    },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditOutlined}
          onClick={() => handleEdit(row.question_id)}
          label="ویرایش سوال"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteGroup.loading && id === row.question_id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteOutlined}
            onClick={() => setId(row.question_id)}
            label="حذف سوال"
            tone="danger"
          />
        ),
    },
  ];

  useEffect(() => {
    id && deleteGroup.reFetch();
  }, [id]);

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="سوالات"
        description="بانک سوالات آزمون‌ها به‌همراه تصویر و پاسخ"
        icon={QuizOutlined}
        actionLabel="افزودن سوال"
        actionIcon={AddRounded}
        onAction={() => setNewModal(true)}
      />

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getQuestion} />

        <ShareTable
          data={questions?.results ?? []}
          columns={columns}
          getPage={getQuestion}
          totalCount={questions?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddGroups close={handleClose} get={getQuestion} edit={edit} />
      </Modal>
    </div>
  );
};

export default Question;
